import React, { useEffect, useState } from 'react';
import EstadoAcreditacion from '../../Components/FormFichaComponents/EstadoAcreditacion';
import Spinner from '@jumbo/components/custom/Spinner';
import { getDatosPrestadorFichasTecnicas } from 'services/api';
import SharedTitle from '../../Components/SharedForms/SharedTitle';
import { TEXT_COLOR_FT } from 'config/config';
////import GuardarYSalirBtn from '../../Components/SharedForms/GuardarYSalirBtn';

const EstadoAcreditacionForm = (props) => {

    const [isLoading, setIsLoading] = useState(true)

    const [isAcreditado, setIsAcreditado] = useState('SI');

    const [datosAcreditacion, setDatosAcreditacion] = useState(null)
    const [complejidadAcreditacion, setComplejidadAcreditacion] = useState('');
    /*   const [administracionEstadoAcreditacion, setAdministracionEstadoAcreditacion] = useState(''); */
    const [numAcreditaciones, setNumAcreditaciones] = useState('');
    const [añoAcreditacion, setAñoAcreditacion] = useState('');
    const [fechaTerminoVigencia, setFechaTerminoVigencia] = useState('');
    const [numRegistroInscripcionSis, setNumRegistroInscripcionSis] = useState('');

    const [estadoAcreditacionText, setEstadoAcreditacionText] = useState('');
    const [numeroResolucion, setNumeroResolucion] = useState('');
    const [porcentajeObtenido, setPorcentajeObtenido] = useState('0');
    const [entidadAcreditadora, setEntidadAcreditadora] = useState('');

    const entidadesAcreditadorasList = []
    const numeroAcreditacionesList = []
    const estadosAcreditacionList = []

    const handleChangeRadio = evt => {
        setIsAcreditado(evt.target.value);
    };

    useEffect(() => {
        getDatosPrestadorFichasTecnicas()
            .then(res => {

                if (res.data.acreditaciones.length > 0) {

                    setDatosAcreditacion(res.data.acreditaciones[0])
                    setIsAcreditado('SI');
                    //setComplejidadAcreditacion(res.data.prestador_acreditado_desc.complejidad);
                    setEntidadAcreditadora(res.data.acreditaciones[0].entidad_acreditadora)
                    setNumAcreditaciones(res.data.acreditaciones[0].estado_final)
                    setAñoAcreditacion(res.data.acreditaciones[0].anio_resolucion);
                    setNumeroResolucion(res.data.acreditaciones[0].nro_resolucion)
                    setFechaTerminoVigencia(res.data.acreditaciones[0].vigencia_acreditacion);
                    setNumRegistroInscripcionSis(res.data.acreditaciones[0].nro_registro);
                    setEstadoAcreditacionText(res.data.acreditaciones[0].estado_actual)
                } else {

                    setDatosAcreditacion(res.data.prestador_acreditado_desc)
                    setIsAcreditado('NO');
                }
            })
            .catch(e => {
                console.error(e)
            })
            .finally(f => {
                setIsLoading(false)
            })
    }, [])

    return (
        <>
            {isLoading ?
                <Spinner show={isLoading} />
                :
                <div style={{ width: '100%', flexBasis: '100%', marginBottom:5, color:TEXT_COLOR_FT, backgroundColor:'white' }} elevation={0}>

                    <SharedTitle
                        title={'Acreditación'}
                    />

                    <EstadoAcreditacion
                        datosAcreditacion={datosAcreditacion}
                        entidadesAcreditadorasList={entidadesAcreditadorasList}
                        numeroAcreditacionesList={numeroAcreditacionesList}
                        estadosAcreditacionList={estadosAcreditacionList}
                        isAcreditado={isAcreditado}
                        handleChangeRadio={handleChangeRadio}
                        complejidadAcreditacion={complejidadAcreditacion}
                        setComplejidadAcreditacion={setComplejidadAcreditacion}
                        numAcreditaciones={numAcreditaciones}
                        setNumAcreditaciones={setNumAcreditaciones}
                        añoAcreditacion={añoAcreditacion}
                        setAñoAcreditacion={setAñoAcreditacion}
                        fechaTerminoVigencia={fechaTerminoVigencia}
                        setFechaTerminoVigencia={setFechaTerminoVigencia}
                        numRegistroInscripcionSis={numRegistroInscripcionSis}
                        setNumRegistroInscripcionSis={setNumRegistroInscripcionSis}
                        estadoAcreditacionText={estadoAcreditacionText}
                        setEstadoAcreditacionText={setEstadoAcreditacionText}
                        numeroResolucion={numeroResolucion}
                        setNumeroResolucion={setNumeroResolucion}
                        porcentajeObtenido={porcentajeObtenido}
                        setPorcentajeObtenido={setPorcentajeObtenido}
                        entidadAcreditadora={entidadAcreditadora}
                        setEntidadAcreditadora={setEntidadAcreditadora}
                    />
                </div>
            }
            {
                isLoading ? null : null
            }
        </>
    )

}

export default EstadoAcreditacionForm